module.exports = __webpack_public_path__ + "static/media/Custom4.92ae9428.png";